import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "./Firebase";

export default function Login() {

    const [businessinfo, setBusinessInfo] = useState("")

    function fetchData() {
        db.collection("businessinfo").onSnapshot((snapshot) => {
            if (!snapshot.empty) {
                const firstDoc = snapshot.docs[0].data(); // Get the first document's data
                setBusinessInfo(firstDoc);
            }
        });
    }
    useEffect(() => {
        fetchData();
    }, [])

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-2 custom-navbar">
                <div className="container-fluid px-3">
                    <Link to="/" className="navbar-brand d-flex align-items-center">
                        <img src="/images/logoo.jpeg" alt="H98 Logo" width="60" height="60" className="me-2 rounded-circle" />
                        <h2 className='mt-2' style={{ fontFamily: "inherit" }}>{businessinfo.businessname}</h2>
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                        <ul className="navbar-nav align-items-lg-center gap-2">
                            <li className="nav-item">
                                <Link to="/" className="nav-link fw-bold text-dark">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/About" className="nav-link fw-bold text-dark">About Us</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Products" className="nav-link fw-bold text-dark">Our Products</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Contact" className="nav-link fw-bold text-dark">Support</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Distributor" className="btn btn-danger fw-bold px-3">
                                    Become a Distributor
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
}